import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import '../styles/ExportVote.css';
import fr from '../locales/fr';
import en from '../locales/en';

function Answer({ ws }) {
    const navigate = useNavigate();
    const location = useLocation();
    const browserLang = navigator.language || navigator.userLanguage;
    const language = browserLang.startsWith('fr') ? 'fr' : 'en';
    const translations = language === 'fr' ? fr : en;

    const allowed =
        location.state?.fromAuthorized ||
        sessionStorage.getItem('canAccessAnswer');

    useEffect(() => {
        const handleWebSocketMessage = (event) => {
            const message = event.data;
            const ROOM = localStorage.getItem('UNITY');

            switch (message) {
                case ROOM + ":START":
                    ws.onmessage = null;
                    ws.send(ROOM + ":CHECKSTATE");
                    sessionStorage.setItem('canAccessOnTV', 'true');
                    navigate("/onTV", { state: { fromAuthorized: true } });
                    break;
                case ROOM + ":WAIT":
                    ws.onmessage = null;
                    ws.send(ROOM + ":CHECKSTATE");
                    sessionStorage.setItem('canAccessWaitingState', 'true');
                    navigate("/waitingState", { state: { fromAuthorized: true } });
                    break;
                case ROOM + ":CLOSE":
                    ws.onmessage = null;
                    ws.send(ROOM + ":CHECKSTATE");
                    sessionStorage.setItem('canAccessRestart', 'true');
                    navigate("/restart", { state: { fromAuthorized: true } });
                    break;
                case ROOM + ":VOTE":
                    ws.onmessage = null;
                    ws.send(ROOM + ":CHECKSTATE");
                    sessionStorage.setItem('canAccessExportVote', 'true');
                    navigate("/exportVote", { state: { fromAuthorized: true } });
                    break;
                default:
                    console.log("Message non reconnu:", message);
            }
        };

        // Mettre en place l'écouteur d'événements WebSocket
        ws.onmessage = handleWebSocketMessage;
        //usePageCheck()
    }, [ws, navigate]);
    const [answerText, setAnswerText] = useState('');
    const [soumettreErreur, setSoumettreErreur] = useState('');

    useEffect(() => {
        if (allowed) {
            sessionStorage.removeItem('canAccessAnswer');
        }
    }, [allowed]);

    if (!allowed) {
        return <Navigate to="/" replace />;
    }

    const handleInputChange = (event) => {
        setAnswerText(event.target.value.replace(/\p{Extended_Pictographic}/gu, ''));
    };

    const handleSubmit = () => {
        var unityID = localStorage.getItem('UNITY');
        if (answerText === '') {
            setSoumettreErreur('Veuillez inscrire une réponse');
        }
        else {
            ws.send(unityID + ":ANþ" + answerText); // Envoyer la réponse saisie
            sessionStorage.setItem('canAccessOnTV', 'true');
            navigate('/onTV', { state: { fromAuthorized: true } });
        }
    };
    return (
        <div style={{ position: 'relative', minHeight: '100vh' }}>
            <div className="canvas-container">
                <h2 className="title">Réponse</h2>
                <input
                    className='champreponse'
                    type="text"
                    value={answerText}
                    onChange={handleInputChange}
                    placeholder="Entrez votre réponse ici..."
                />
                {soumettreErreur && <span style={{ color: 'red' }}>{soumettreErreur}</span>}
                <button onClick={handleSubmit} className='bouttonsoumettre'>Soumettre</button>
            </div>
        </div>
    );

}

export default Answer;
